function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

import { dateFormation } from "../mocks/time";
import { getDate } from "./date";
export var filterEventsByMonth = function filterEventsByMonth(events, month) {
  return events.filter(function (e) {
    var eventMonth = new Date(e.start_time * 1000).getMonth();
    var eventYear = new Date(e.start_time * 1000).getFullYear();
    return eventMonth === month.monthNum && eventYear === month.year;
  });
};
export var getFilterMonths = function getFilterMonths(events) {
  var intArray = events.map(function (e) {
    return JSON.stringify({
      monthNum: getDate(e.start_time).numMonth,
      month: getDate(e.start_time).initMonth,
      year: getDate(e.start_time).year,
    });
  });
  var newArr = [].concat(new Set(intArray)).map(function (el, i) {
    var parseEl = JSON.parse(el);
    return _extends({}, parseEl, {
      id: parseEl.month + " " + i,
      date_from: dateFormation(parseEl, "from"),
      date_to: dateFormation(parseEl, "to"),
    });
  });
  return newArr;
};
